import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postUserAccount } from '@arrived/api_v2';
import { Account, AccountCreateRequest } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { accountsPrimaryKeyFn, currentUserKeyFn, userSsnKeyFn } from '../users';
import { accountsKeyFn } from './accounts.keys';

export function usePostAccountMutation(options?: UseMutationOptions<Account, AccountCreateRequest>) {
  const queryClient = useQueryClient();

  return useMutation((request) => postUserAccount(request), {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.setQueryData(accountsPrimaryKeyFn(), data);
      queryClient.setQueryData(accountsKeyFn(data.id), data);
      queryClient.setQueryData(currentUserKeyFn(), data.primaryUser);

      queryClient.invalidateQueries(accountsPrimaryKeyFn());
      queryClient.invalidateQueries(accountsKeyFn(data.id));
      queryClient.invalidateQueries(currentUserKeyFn());
      queryClient.invalidateQueries(userSsnKeyFn(data.primaryUser.id));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
